import React from "react";

import { Card } from "@bared/ui";

import { useWishlistProducts } from "~/hooks/useWishlistNew";

import { ProductCard } from "~/components/ProductCard";

import { AnalyticsViewItemListProvider } from "~/providers/AnalyticsViewItemListProvider";

export function WishlistCard() {
  const { isPending, products } = useWishlistProducts();

  return (
    <AnalyticsViewItemListProvider
      itemListId="wishlist"
      itemListName="Wishlist"
    >
      <Card title="My Wishlist" isLoading={isPending} variant="boxed-outside">
        {0 < products.length ? (
          <div className="grid grid-cols-2 gap-mini">
            {products.map((product, index) => (
              <ProductCard
                {...product}
                index={index}
                key={product.handle}
                sizes="50vw"
              />
            ))}
          </div>
        ) : isPending ? (
          <p>Loading...</p>
        ) : (
          <p>You don't have any items in your wishlist yet.</p>
        )}
      </Card>{" "}
    </AnalyticsViewItemListProvider>
  );
}
